import React, { useContext } from 'react';
import { Context } from '../../store/reducer';
import {id2Icon, legendArrays} from './config';
import infoIcon from '../../assets/img/icon_info.png';

/**
 * 可視化5専用の左メニュー表示ロジック
 * @param menuName
 * @param layerList
 * @param category
 * @returns {JSX.Element}
 * @constructor
 */
const Component = ({ menuName, options, layerOrderList,category }) => {
  const { state, dispatch } = useContext(Context);
  
  /**
   * 背景色をアイコン風に表示するかどうか。
   * 1色塗りの場合のメニュー時に主に表示している。
   * @param type
   * @param id
   * @returns {boolean}
   */
  const hasColorIcon = (type, id) => {
      
    if (type !== "vector") {
        return false;
    }

    return [
      "tsunami-saigai",
      "tosha_73_1",
      "tosha_73_2", 
      "tosha_73_4",
      "73_kyukeisya_tokubetsukeikai",
      "tosha_73_3",
      "vis_93_1",
      "vis_93_2",
      "vis_93_3",
      "vis_98_1",
      "vis_98_2",
      "vis_98_36",
      "vis_98_37",
      "vis_98_38",
      "vis_98_39",
      "vis_98_40",
      "vis_98_41",
      "vis_98_42",
      "vis_98_43",
      "vis_98_44",
      "vis_98_45",
      "vis_98_46",
      "vis_98_47",
      "vis_98_48",
      "vis_98_49",
      "vis_98_50",
      "vis_98_51",
      "vis_98_52",
      "vis_98_53",
      "vis_98_54",
      "vis_98_55",
      "vis_98_56",
      "vis_98_57"
    ].includes(id)
  }

  /**
   * アイコン画像メニューに表示するかどうか。
   * @param type
   * @param id
   * @returns {boolean}
   */
  const hasImageIcon = (type, id) => {

    if (type !== "marker" && type !== "geojson") {
      return false;
    }

    return [
      "vis_95_7",
      "vis_98_3",
      "vis_98_4",
      "vis_98_5",
      "vis_98_6",
      "vis_98_7",
      "vis_98_8",
      "vis_98_9",
      "vis_98_10",
      "vis_98_11",
      "vis_98_12",
      "vis_98_13",
      "vis_98_14",
      "vis_98_15",
      "vis_98_16",
      "vis_98_17",
      "vis_98_18",
      "vis_98_19",
      "vis_98_20",
      "vis_98_21",
      "vis_98_22",
      "vis_98_23",
      "vis_98_24",
      "vis_98_25",
      "vis_98_26",
      "vis_98_27",
      "vis_98_28",
      "vis_98_29",
      "vis_98_30",
      "vis_98_31",
      "vis_98_32",
      "vis_98_33",
      "vis_98_34",
      "vis_98_35",
      "vis_96_1"
    ].includes(id)
  }
  
  /**
   * 各メニューの選択肢部分のliタグを作成する。
   * @param option
   * @returns {JSX.Element}
   */
  const createLiOption = (option) => {

    return option && (
      <li>
        <div className="gnav-list-ac">
          <p className={option.checkboxDisabled ? "" : "f-check"} key={option.label}>
            {
              // 準備中のチェックボックスなし表示に対応したチェックボックスの表示
              (!option.checkboxDisabled) &&
              <input type="checkbox" id={option.id} checked={state[option.id].checked}
                     onChange={() => dispatch({
                       type    : 'TOGGLE_CHECKED',
                       category: option.id
                     })}/>
            }

            <label htmlFor={option.id}>

              {/* vectorの場合、左メニューでチェックボックスの右に背景色だけの四角を出している処理 */}
              {
                hasColorIcon(option.type, option.id) &&
                <span className={"icon-marker icon-no " + option.legendColorClass}></span>
              }
              
              {/* markerの場合、左メニューでチェックボックスの右にアイコン画像を出している処理 */}
              {
                hasImageIcon(option.type, option.id) &&
                <span className={"icon-marker"}><img src={id2Icon[option.id]} alt={option.label}/></span>
              }

              <span className="layer-name">
                {/* 改行を有効にするため改行コードでsplit */}
                {option.label.split('\n').map(t => (<>{t}<br/></>))}
                                </span>

              {/* 注釈ポップアップ(1番下の階層の場合) */}
              {
                (["vis_95_1",
                   "vis_95_2", 
                   "vis_95_3",
                   "vis_95_7",
                   "vis_98_35",
                   "vis_98_1",
                   "vis_98_2",
                   "vis_98_36",
                   "vis_98_54",
                   "vis_98_55",
                   ].includes(option.id)) &&

                <span className="icon-marker is-info">
                <button type={"button"}
                        onClick={() => dispatch({
                          type    : 'SET_IS_EXPLANATION_POPUP_OPENED',
                          category: option.id,
                          payload : !state[option.id].showModal
                        })}>
                  <img src={infoIcon} alt={"注釈表示アイコン"}/>
                </button>
                </span>
              }
              
            </label>
          </p>

          {
            legendContent(option.id)
          }

        </div>
      </li>
    )
  }

  /**
   * メニューの凡例部分を作成する。
   * @param id
   * @returns {JSX.Element}
   */
  const legendContent = (id) => {
    
    // 河川浸水想定区域図（想定最大規模）、高潮浸水想定図（想定最大規模）
    if ([
      "kasen-saidai",
      "takashio-saidai"
    ].includes(id)) {
      return (
        <>
          <div className="ac-item ac-hanrei"></div>
          <ul className="ac-hanrei-list">
            {legendArrays[id].map(legend => {

              return (
                <>
                  <li>{legend.subTitle}</li>
                  <li>
                    <hr/>
                  </li>
                  <li>
                    <div className="ac-hanrei-item">
                        <span className={"icon-marker icon-no " + legend.class} style={{background: legend.color}}>
                        </span>
                      <span className="icon-name">{legend.range}</span>
                    </div>
                  </li>
                </>
              )
              }
            )}
          </ul>
        </>
      );
    } else if ([
      "85_2_3_land_site", 
      "85_3_3_building_building",
      "vis_95_1",
      "vis_95_2",
      "vis_95_3",
      "vis_95_4",
      "vis_95_5",
      "vis_95_6",
    ].includes(id)) {
      // 土地利用現況（都市計画基礎調査）、建物利用現況（都市計画基礎調査）
      return (
      <>
        <div className="ac-item ac-hanrei"></div>
        <ul className="ac-hanrei-list">
          {legendArrays[id].map(legend => {

            // ハズレ値チェック用の凡例要素は表示しない
            if (legend.type && legend.type === "hidden") {
              return;
            }

            return (
              <>
                <li>{legend.subTitle}</li>
                <li>
                  <div className="ac-hanrei-item">
                    <span className={"icon-marker icon-no " + legend.class} style={{background: legend.color}}></span>
                    <span className="icon-name">{legend.range}</span>
                  </div>
                </li>
              </>
            )
            }
          )}
        </ul>
      </>)
    }
  }
  
  return (
    <div className="gnav-list-ac is-line">
      {
        category.useAccordion && 
        <p className={"gnav-category-ttl"}>{menuName}</p>
      }

      {
        <>
          {
            category.useAccordion &&
            <div className={category.activateAccordion ? "ac-item is-active" : "ac-item"}></div>
          }

          {/* アコーディオンを開いた状態にするかどうか。アコーディオン自体を使うかどうかで少し判定が複雑なので注意 */}
          <ul style={
              category.useAccordion
                ? category.activateAccordion ? {display: "block"} : {}
                : {display: "block"}}>
            
            {
              layerOrderList && layerOrderList.map(loElement => {

              // 通常のレイヤーの場合
              if (loElement.type === "element") {

                const option = options.find(opt => opt.id === loElement.id);
                return createLiOption(option)

              } else if (loElement.type === "list") {
              
                // 3階層まである場合
                return (
                  <>
                    <li>
                      <div className="gnav-list-ac">
                        <p className={""} key="second">

                          <label htmlFor="second" className="is-info">
                            <span className="layer-name">{loElement.subLayerName}</span>

                            {/* 注釈ポップアップ(アコーディオンの親階層の場合) */}
                            {
                              (["vis_95_4",
                                "vis_98_3",
                                "vis_98_14",
                                "vis_98_19",
                                "vis_98_22",
                                "vis_98_29",
                                "vis_98_30",
                                "vis_98_32",
                                "vis_98_37",
                                "vis_98_39",
                                "vis_98_52",
                                "vis_98_56"
                                ].includes(loElement.subLayerId)) &&

                              <span className="icon-marker is-info">
                              <button type={"button"}
                                      onClick={() => dispatch({
                                        type    : 'SET_IS_EXPLANATION_POPUP_OPENED',
                                        category: loElement.subLayerId,
                                        payload : !state[loElement.subLayerId].showModal
                                      })}>
                                <img src={infoIcon} alt={"注釈表示アイコン"}/>
                              </button>
                              </span>
                          }

                        </label>



                          

                        </p>
                        <div className={category.activateAccordion ? "ac-item is-active" : "ac-item"}></div>

                        <ul className="ac-hanrei-list">
                          {
                            loElement.subLayerList.map(subLoElement => {
                              const option = options.find(opt => opt.id === subLoElement.id);
                              return createLiOption(option)
                            })
                          }
                        </ul>

                      </div>
                    </li>
                  </>
                )
              }

              return <></>
            })

            }
          </ul>
        </>
      }
    </div>
  );
};

export default Component;
